<template>
    <div>
        <user-login
            v-if="shouldShowLoginSection()"
            v-model="user"
            v-on:input="loginStateChanged">
        </user-login>

        <template v-if="!shouldShowLoginSection()">
            <email-input
                v-model="user.email"
                :disabled="user.loggedIn">
            </email-input>
        </template>

        <fieldset>
            <input-with-validation
                type="text"
                label="First Name"
                regex="^.{1,255}"
                max-length=255
                required="true"
                failure-msg="Please provide your first name"
                half-width="true"
                v-model="user.firstName">
            </input-with-validation>

            <input-with-validation
                type="text"
                label="Last Name"
                regex="^.{1,255}"
                max-length=255
                required="true"
                failure-msg="Please provide your last name"
                half-width="true"
                v-model="user.lastName">
            </input-with-validation>
        </fieldset>

        <fieldset>
            <input-with-validation
                type="tel"
                label="Mobile Number"
                regex="^.{1,255}"
                max-length=255
                :additional-info-show="isDmnSource"
                additional-info="Used for tracking and confirming your booking only"
                failure-msg="Please provide a valid mobile number"
                v-model="user.phone"
                required="false">
            </input-with-validation>
        </fieldset>

        <fieldset v-if="bookingDetails.shouldShowDobField">
            <dob-selection
                label="Birthday"
                :required="bookingDetails.dobRequired"
                v-model="user.dob"
                failure-msg="Please enter a valid date of birth">
            </dob-selection>
        </fieldset>
    </div>
</template>

<script>
  import { Source } from '../models/Source'
  import userLogin from './userLogin'
  import inputWithValidation from './inputWithValidation'
  import dobSelection from './dobSelection'
  import emailInput from './emailInput'
  import tagInput from './tagInput'

  export default {
    name: 'userDetailsForm',
    components: {
      userLogin,
      inputWithValidation,
      dobSelection,
      emailInput,
      tagInput
    },
    props: [
      'bookingDetails',
      'value'
    ],
    data () {
      return {
        user: this.value,
        showSpecialRequest: false,
        loggedIn: false,
        disableSubmitBtn: false
      }
    },
    methods: {
      shouldShowLoginSection () {
        return this.isDmnSource
      },

      passesValidation () {
        let valid = true

        this.$children.forEach((child) => {
          child.highlightError()

          if (!child.isValid()) {
            valid = false
          }
        })

        return valid
      },

      loginStateChanged (user) {
        this.user = user

        this.$emit('input', user)
      }
    },
    computed: {
      isDmnSource: function () {
        return this.$root.dmnOptions.from === Source.designmynight
      },
      isPartnerSource: function () {
        return this.$root.dmnOptions.from === Source.partner
      }
    }
  }
</script>



// WEBPACK FOOTER //
// userDetailsForm.vue?675beb3b